module.exports = "<p-growl [(value)]=\"msgs\"></p-growl>\r\n\r\n<div class=\"container\">\r\n \r\n\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/lp/lp-invoice-details/lp-invoice-details.component.html
// module id = ../../../../../src/app/lp/lp-invoice-details/lp-invoice-details.component.html
// module chunks = main